<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    
    <div class="container pt-lg-md">
      
      

      <div class="row justify-content-center" style="background-color:white;border-radius: 20px 20px 0px 0px;">
        <div class="col-10">
          <h2 style="margin-top:15px">Listado de inscripciones</h2>
        </div>
        
        <div class="col-2">
           <base-button
            type="primary"
            icon="ni ni-fat-add"
            size="lg"
            disabled
            @click="crearForm"
            style="float:right;margin-botton:12px;margin-top:10px"
            >Inscribir</base-button
          >

        </div>
        <div class="col-4">
          <b-form-group
            label="Filtro"
            label-for="filter-input"
            label-cols-sm="2"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Escribe para buscar"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Borrar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-3">
            <b-form-group
              label="Por página"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="6"
              label-cols-lg="6"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
              ></b-form-select>
            </b-form-group>
          </div>

          <div class="col-3">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </div>
          </div>


          <div class="row justify-content-center" style="background-color:white;">
          
        <b-table 
          responsive
          :items="items"
          :fields="fields"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
          :current-page="currentPage"
          :per-page="perPage"
          >
            <template #cell(nombre)="row">
              {{ row.item.nombre }}
            </template>

            <template #cell(actions)="row">
              <b-button
                size="sm"
                @click="verInscripcion(row.item, row.index, $event.target)"
                class="mr-1"
              >
                Ver
              </b-button>
              <b-button size="sm" @click="editarForm(row.item)">
                Editar 
              </b-button>
            </template>

            <template #row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">
                    {{ key }}: {{ value }}
                  </li>
                </ul>
              </b-card>
            </template>
          </b-table>
      </div>
    </div>
    <modal-inscripciones
        :typeForm="typeForm"
        :inscripcion="inscripcion"
        :activarModal="activarModal"
        :cambioForm="cambioForm"
        @listarInscripciones="getInscripciones"
      ></modal-inscripciones>
  </section>
</template>
<script>

import ModalInscripciones from './ModalInscripciones.vue';
export default {
  components: {
    ModalInscripciones,
  },
  data() {
    return {
      fields: [
          { key: 'nombre', label: 'Nombre', sortable: true, sortDirection: 'desc' },
          { key: 'apellido', label: 'Apellido', sortable: true, class: 'text-center' },
          { key: 'catedra', label: 'Cátedra', sortable: true, class: 'text-center' },
          { key: 'cedula', label: 'Cédula', sortable: true, class: 'text-center' },
          { key: 'correo', label: 'Correo', sortable: true, class: 'text-center' },
          { key: 'actions', label: 'Actions' }

        ],
      items: [],
      typeForm: "",
      inscripcion: [],
      activarModal: false,
      cambioForm: "",
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: "Mostrar 100" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  created() {
    this.getInscripciones();
  },
  methods: {
    async getInscripciones() {
      this.activarModal = false;
      try {
        const { data } = await this.$api.get("inscriptions");
        this.items = data.data;
        
      } catch (error) {
        console.log("hubo un error al cargar las inscripciones");
      }
    },
    crearForm() {
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Crear";
    },
    async editarForm(inscripcion) {
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Editar";
      this.inscripcion = inscripcion;
    },
    async eliminarInscripcion(inscripcion) {
      var url = "inscripciones/" + inscripcion.id;
      var method = "delete";

      try {
        await this.$api({
          url: url,
          method: method,
        });
      } catch (e) {
        if (e.response == "422") {
          console.log("422" + " " + e);
        } else {
          console.log(e);
        }
      }
      this.getInscripciones();
    },
    verInscripcion(item, index, button){
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Activo";
      this.inscripcion = item;
      console.log(item.nombre);
      

    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },
  watch: {
    modalActive: function (val) {
      if (this.typeForm === 'Crear') {
        this.typeForm = 'Editar'        
      }else{
        this.typeForm = 'Crear';
      }
    },
    items:function(){
      this.totalRows = this.items.length;
    }
  },
};
</script>
